var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    transform: "translate(-685 -957)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(685 957)",
    fill: "#07b4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M35.627,30.383a2.361,2.361,0,0,0-3.572,0c-.837.829-1.67,1.654-2.491,2.5a.492.492,0,0,1-.69.128c-.538-.294-1.116-.535-1.635-.856A25.89,25.89,0,0,1,21,26.467a14.8,14.8,0,0,1-2.239-3.587.515.515,0,0,1,.128-.659c.837-.806,1.65-1.635,2.472-2.464a2.354,2.354,0,0,0,0-3.657c-.651-.659-1.306-1.306-1.956-1.964s-1.352-1.352-2.049-2.018a2.384,2.384,0,0,0-3.572,0c-.841.829-1.65,1.677-2.506,2.491a4.068,4.068,0,0,0-1.278,2.743,11.622,11.622,0,0,0,.9,5,30.4,30.4,0,0,0,5.416,8.984A33.394,33.394,0,0,0,27.368,40a15.991,15.991,0,0,0,6.125,1.782,4.474,4.474,0,0,0,3.851-1.468c.717-.8,1.522-1.53,2.282-2.293a2.375,2.375,0,0,0,0-3.634Q37.642,32.378,35.627,30.383Z",
    transform: "translate(691.518 962.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M65.809,23.789A25.956,25.956,0,0,0,52.037,10.082a.992.992,0,0,0-1.306.569A1.046,1.046,0,0,0,51.285,12a23.937,23.937,0,0,1,12.7,12.637,1,1,0,0,0,.914.612.965.965,0,0,0,.411-.093,1.046,1.046,0,0,0,.5-1.368Z",
    transform: "translate(666.602 963.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M49.942,26.351A14.5,14.5,0,0,1,57.644,34a.968.968,0,0,0,.883.589.937.937,0,0,0,.387-.089,1.011,1.011,0,0,0,.5-1.325,16.457,16.457,0,0,0-8.74-8.67.961.961,0,0,0-1.263.535A1.007,1.007,0,0,0,49.942,26.351Z",
    transform: "translate(667.414 954.663)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallButton);
export default __webpack_public_path__ + "static/media/callButton.a7a203dc574201708f154733b60fc885.svg";
export { ForwardRef as ReactComponent };